export default "__VITE_ASSET___kiIf9uK__"